import { getToken } from 'Global/AppService';
import * as AuthorizationConstants from './AuthorizationConstants';
import AuthorizationService from './AuthorizationService';

export const showAuthorizationErrorModalAction = (showModal) => {
    return {type:AuthorizationConstants.AUTH_ERROR_MODAL, displayModal: showModal}
}

export const fetchAllowedDeviceFeatures = (instanceId) =>{
	return (dispatch) => {		
		function callback(success, err){
			console.log('callback received for auth call ################### - ' + {success});
			if (success) {
                console.log('result #####################' + success.result);
                console.log('result Length #####################' + success.result.length);
				if(success.result && success.result.length >= 0){
					dispatch(fetchAllowedDeviceFeaturesSuccess(success));
				}
			}
            else
            {
                dispatch(fetchAllowedDeviceFeaturesFailure(err));
            }
		}
		AuthorizationService.fetchAllowedFeaturesForDevice(instanceId,callback);
	}
}

const fetchAllowedDeviceFeaturesSuccess = (result) =>{
	return { type:AuthorizationConstants.AUTH_ALLOWED_DEVICE_FEATURES_SUCCESS, newState : result};
}

const fetchAllowedDeviceFeaturesFailure = (result) =>{
	return { type:AuthorizationConstants.AUTH_ALLOWED_DEVICE_FEATURES_FAILURE, newState : result};
}

export const authorize = (url, scope) => {
	return async (dispatch) => {
		dispatch(authorizeRequest());
		try {
			const accessToken = await getToken(scope);
			const headers = {
				Authorization: `Bearer ${accessToken}`
			};
			
			const response = await fetch(url, {
				method: 'GET',
				headers
			});

			if (response.status === 200) {
				const data = await response.json();
				if (data?.result?.url) {
					window.location.href = data?.result?.url;
				} else {
					dispatch(authorizeSuccess(data));
				}
			} else if(response.status === 401) {
				throw new Error('Unauthorized access. Please login again.');
			} else {
				const data = await response?.json();
				throw new Error(data?.message);
			}
		} catch(err) {
			console.error(err);
			dispatch(authorizeError(err));
		}
	}
}

const authorizeRequest = () => {
	return { type: AuthorizationConstants.UM_AUTHORIZE_REQUEST };
}

const authorizeSuccess = (payload) => {
	return { type: AuthorizationConstants.UM_AUTHORIZE_SUCCESS, payload };
}

const authorizeError = (payload) => {
	return { type: AuthorizationConstants.UM_AUTHORIZE_FAILURE, payload };
}

export const resetAuthorizeFailureStatus = (payload) => {
	return { type: AuthorizationConstants.UM_RESET_AUTHORIZE_FAILURE_STATUS };
}
